//import { ref } from 'vue'
import type { Ref } from 'vue'
//directly manipulates the tableData ref
export function useTableSorter(tableData: Ref<Array<any>>) {
  //const filtered = ref(tableData.value)

  function sortAscending(colName) {
    console.log(`filter table sortAscending(${colName})`)
    const fieldType = typeof tableData.value[0][colName]
    const firstVal = tableData.value[0][colName]
    console.log('tableData type of colname' + colName + ' = ' + fieldType)
    if (typeof firstVal == 'number') {
      //colName == 'id') {
      tableData.value.sort((a, b) => {
        return a[colName] - b[colName]
      })
    } else {
      console.log('tableData type of colname' + colName + ' = ' + typeof tableData.value[0][colName])

      tableData.value.sort((a, b) => {
        let aStr = ''
        let bStr = ''
        //check if null values, treat as empty strings
        if (a[colName] && a[colName] != null) {
          aStr = a[colName].toLowerCase()
        }
        if (b[colName] && b[colName] != null) {
          bStr = b[colName].toLowerCase()
        }

        //const aStr = a[colName]==null ? a[colName].toLowerCase() : "";
        //const bStr = b[colName]==null ? b[colName].toLowerCase() : "";

        if (aStr < bStr) {
          return -1
        }
        if (aStr > bStr) {
          return 1
        }
        //strings must be equal
        return 0
      })
    }
  }

  function sortDescending(colName) {
    console.log(`filter table sortDescending(${colName})`)
    const fieldType = typeof tableData.value[0][colName]
    const firstVal = tableData.value[0][colName]
    console.log('tableData type of colname' + colName + ' = ' + fieldType)
    if (typeof firstVal == 'number') {
      tableData.value.sort((a, b) => {
        return b[colName] - a[colName]
      })
    } else {
      console.log('tableData type of colname' + colName + ' = ' + typeof tableData.value[0][colName])

      tableData.value.sort((a, b) => {
        //check if null values, treat as empty strings
        const aStr = a[colName] ? a[colName].toLowerCase() : ''
        const bStr = b[colName] ? b[colName].toLowerCase() : ''

        if (aStr < bStr) {
          return 1
        }
        if (aStr > bStr) {
          return -1
        }
        //strings must be equal
        return 0
      })
    }
  }

  return { sortAscending, sortDescending }
}
